import type React from "react"

export const SpeedometerIcon = (props: React.ComponentProps<"svg">): JSX.Element => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' {...props}>
            <path
                fill='currentColor'
                d='M5.67 20.74a10 10 0 1112.664-.002l-2.148-2.147a.997.997 0 011.41-1.41l.724.724A8.075 8.075 0 0019.937 14h-1.02a1 1 0 110-2h1.02a8.074 8.074 0 00-1.617-3.905l-.722.721a1 1 0 11-1.414-1.414l.721-.722A8.019 8.019 0 0013 5.063V6a1 1 0 01-2 0v-.937A8.021 8.021 0 007.095 6.68l.721.722a1 1 0 01-1.414 1.414l-.722-.721A8.075 8.075 0 004.063 12h1.02a1 1 0 010 2h-1.02a8.072 8.072 0 001.617 3.905l.723-.722a.999.999 0 011.412 1.412L5.67 20.74z'
            ></path>
            <path
                fill='currentColor'
                d='M16.455 11.005a1 1 0 00-1.366-.366l-3.646 2.105a1 1 0 001 1.732l3.646-2.105a1 1 0 00.366-1.366z'
            ></path>
        </svg>
    )
}
